<script setup lang="ts">
defineProps({
    value: {
        type: String,
    },
    required: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <label class="block font-semibold text-sm text-gray-700">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>

        <span v-if="required" class="ml-1 text-danger-500">*</span>
    </label>
</template>
